module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Estimulacion.ddc335a4.png";